export default __webpack_public_path__ + "static/media/LAS0920.34I-41373_-24680_0.3bd23cd5.jpg";